module.exports = __webpack_public_path__ + "img/portrait-028.e1f10c04.jpg";